export default __webpack_public_path__ + "static/media/email.75323a01.png";